import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_15333_53181\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"6\" y=\"3\" width=\"12\" height=\"18\"><path d=\"M18 3H6V21H18V3Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_15333_53181)\"><path d=\"M6.46094 16.6809V3.47461H17.5379V16.6809L11.9994 13.1757L6.46094 16.6809Z\" stroke=\"black\" stroke-linejoin=\"round\"></path><path d=\"M6.46094 16.6716V20.5274L11.9994 17.0221L17.5379 20.5274V16.6716L11.9994 13.1758L6.46094 16.6716Z\" stroke=\"black\" stroke-linejoin=\"round\"></path></g>", 2)
  ])))
}
export default { render: render }